import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authTokenInterceptor } from '@dental-ui/auth';
import { provideTheme } from '@dental-ui/ui';
import { provideI18n } from '@dental-ui/shared/i18n';
import { provideAccountAppearance } from '@dental-ui/account-layout';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withHashLocation()),
    provideHttpClient(withFetch(), withInterceptors([authTokenInterceptor])),
    provideTheme(),
    provideAccountAppearance(),
    provideI18n(['account']),
  ],
};
